import { render, staticRenderFns } from "./PhoneVerificationForm.vue?vue&type=template&id=41ca51c1&scoped=true&"
import script from "./PhoneVerificationForm.vue?vue&type=script&lang=js&"
export * from "./PhoneVerificationForm.vue?vue&type=script&lang=js&"
import style0 from "./PhoneVerificationForm.vue?vue&type=style&index=0&id=41ca51c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ca51c1",
  null
  
)

export default component.exports